import React from 'react';
import './SummarizeList.css';
import SummarizeTable from '../SummarizeTable/SummarizeTable';
const SummarizeList = () => {
  return (
    <>
      <SummarizeTable />
    </>
  );
};
export default SummarizeList;
